import Backbone from 'backbone';
import * as encodingUtils from '@ardoq/html';
import type { BasicModel as BasicModelBackboneModel } from 'aqTypes';

// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging, @typescript-eslint/no-empty-object-type, @typescript-eslint/no-unused-vars
interface BasicModelClass extends BasicModelBackboneModel {}

// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
declare class BasicModelClass
  extends Backbone.Model
  implements BasicModelBackboneModel
{
  constructor(attributes?: any, options?: any);
}

const BasicModel: typeof BasicModelClass = Backbone.Model.extend({
  _cachedParsedDescription: undefined,
  initialize: function () {},

  getLock: function (this: BasicModelBackboneModel) {
    return this.get('lock');
  },
  name: function (this: BasicModelBackboneModel) {
    return encodingUtils.escapeHTML(this.get('name'));
  },
  getId: function (this: BasicModelBackboneModel) {
    return this.get('_id');
  },
  getDescription: function (this: BasicModelBackboneModel) {
    return this.get('description');
  },
});

export { BasicModel };
